<section class="rep" aria-label="Sent messages">
  <div class="bk-panel rep__panel rep__panel--flush">
    <data-table
      label="Sent messages"
      [seamless]="true"
      [loading]="status === 'loading'"
      [resizable]="false"
      [maxHeight]="'640px'"
      [skeletonColumns]="6"
    >
      @if (status === "error") {
        <app-empty-state
          icon="cloud_off"
          message="The sent messages could not be loaded."
          hint="Check your connection, then try again."
          actionLabel="Try again"
          actionIcon="refresh"
          (action)="reload()"
        />
      } @else if (rows.length > 0) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col">Message</th>
              <th scope="col" class="col-delivery">Delivery</th>
              <th scope="col" class="num col-recipients">Recipients</th>
              <th scope="col" class="num col-failed">Failed</th>
              <th scope="col" class="num col-parts">Parts</th>
              <th scope="col" class="num col-billable">Billable parts</th>
              <th scope="col" class="num col-when">Sent</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.key) {
              <tr
                [class.is-link]="!!row.uuid"
                [attr.tabindex]="row.uuid ? 0 : null"
                (click)="openReport(row)"
                (keydown.enter)="openFromKeyboard($event, row)"
              >
                <td class="col-lead">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ row.subject }}</span>
                    <span class="bk-msg__preview">
                      @if (row.copy) {
                        <bk-sms-text [text]="row.copy" [inline]="true" />
                      } @else {
                        <span class="faint">No message text</span>
                      }
                    </span>
                  </span>
                </td>
                <td class="col-delivery">
                  <bk-delivery [uuid]="row.uuid" [status]="row.message.status" [sentAt]="row.sentAt" />
                </td>
                <td class="num quiet col-recipients">
                  {{ row.summary ? formatCount(row.summary.total) : row.summaryFailed ? "—" : "…" }}
                </td>
                <td class="num col-failed" [class.is-bad]="(row.summary?.failed || 0) > 0" [class.quiet]="!(row.summary?.failed || 0)">
                  {{ row.summary ? formatCount(row.summary.failed) : row.summaryFailed ? "—" : "…" }}
                </td>
                <td
                  class="num quiet col-parts"
                  [matTooltip]="row.estimated ? 'Estimate: personalised fields change the length for each contact' : ''"
                >
                  {{ partsLabel(row) }}
                </td>
                <td class="num col-billable" [attr.aria-label]="billable(row) + ' billable parts'">
                  {{ billable(row) }}<span class="billable-unit" aria-hidden="true"> parts</span>
                </td>
                <td class="num quiet col-when">{{ row.when }}</td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    @if ((row.summary?.failed || 0) > 0) {
                      <button
                        type="button"
                        class="bk-icon-btn"
                        aria-label="See failed numbers"
                        matTooltip="See failed numbers"
                        (click)="$event.stopPropagation(); openReport(row, true)"
                      >
                        <span class="bk-sym" aria-hidden="true">error</span>
                      </button>
                    }
                    @if (row.uuid) {
                      <button
                        type="button"
                        class="bk-icon-btn"
                        aria-label="Open delivery report"
                        matTooltip="Open delivery report"
                        (click)="$event.stopPropagation(); openReport(row)"
                      >
                        <span class="bk-sym" aria-hidden="true">monitoring</span>
                      </button>
                      <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
                    }
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          icon="outgoing_mail"
          [message]="'No messages created in ' + periodText + ' have gone out.'"
          hint="Messages show here by the day they were created, with how they landed and how many SMS parts they used. Try a longer period."
        />
      }
    </data-table>
  </div>

  @if (status === "ready" && rows.length > 0) {
    <p class="rep__note">
      @if (pageParts.messages > 0) {
        <strong>{{ formatCount(pageParts.parts) }}</strong>
        SMS {{ pageParts.parts === 1 ? "part" : "parts" }} across
        {{ pageParts.messages === 1 ? "this message" : "these " + formatCount(pageParts.messages) + " messages" }}{{ pageParts.pending > 0 ? ", " + formatCount(pageParts.pending) + " still counting" : "" }}.
      }
      Billable parts are recipients × parts per message{{ pageParts.estimated ? "; personalised messages are estimates" : "" }}.
    </p>
  }

  @if (status !== "error" && total > 0) {
    <div class="rep__foot">
      <app-pagination
        [currentPage]="page"
        [totalPages]="totalPages"
        [totalItems]="total"
        [pageSize]="size"
        [loading]="status === 'loading'"
        (changePage)="onPage($event)"
        (pageSizeChange)="onPageSize($event)"
      />
    </div>
  }
</section>
